import service from '@/util/service';

// user
export const loginSystem = params => service.jsonPost('/api/loginSystem.do', params);

export const updateUser = params => service.jsonPost('/api/system/user/updateUserInfo.do', params);

export const updatePasswd = params => service.jsonPost('/api/system/user/resetUserPassword.do', params);

export const logout = () => service.jsonPost('/api/logout.do');

export const getUserInfo = () => service.jsonGet('/api/index.do');



// WEBPACK FOOTER //
// ./src/api/user.js